import { darken, getValue } from "../utils.js";

export const GLOBAL_TABLE = {
  "Table.Space.Around": {
    defaultValue: "default"
  },
  "Table.Space.Around.Top": {
    defaultValue: "2px"
  },
  "Table.Space.Around.Right": {
    defaultValue: "2px"
  },
  "Table.Space.Around.Bottom": {
    defaultValue: "2px"
  },
  "Table.Space.Around.Left": {
    defaultValue: "2px"
  },

  "Table.Height.Type": {
    defaultValue: "fixed"
  },

  "Table.Color": {
    ref: "Color.Transparent"
  },

  "Table.Title.Bg.Color": {
    ref: "Color.Transparent"
  },
  "Table.Title.Padding.Top": {
    defaultValue: "0px"
  },
  "Table.Title.Padding.Right": {
    defaultValue: "0px"
  },
  "Table.Title.Padding.Bottom": {
    defaultValue: "0px"
  },
  "Table.Title.Padding.Left": {
    defaultValue: "0px"
  },
  "Table.Title.Font.Size": {
    ref: "Font.Size.16"
  },
  "Table.Title.Color": {
    ref: "Color.Gray.800"
  },
  "Table.Title.Font.Weight": {
    ref: "Font.Weight.SemiBold"
  },
  "Table.Header.Bg.Color": {
    ref: "Color.Gray.200"
  },
  "Table.Header.Hover.Bg.Color": {
    ref: "Color.Gray.300"
  },
  "Table.Header.Font.Size": {
    ref: "Font.Size.14"
  },
  "Table.Header.Color": {
    ref: "Color.Gray.800"
  },
  "Table.Header.Font.Weight": {
    ref: "Font.Weight.SemiBold"
  },
  "Table.Header.Icon.Color": {
    ref: "Color.Gray.700"
  },
  "Table.Row.Font.Size": {
    ref: "Font.Size.14"
  },
  "Table.Row.Color": {
    ref: "Color.Gray.800"
  },
  "Table.Row.Font.Weight": {
    ref: "Font.Weight.Medium"
  },
  "Table.Row.Line.Height": {
    ref: "Line.Height.Base"
  },
  "Table.Row.Letter.Spacing": {
    ref: "Letter.Spacing.Base"
  },
  "Table.Row.Border.Color": {
    ref: "Color.Gray.200"
  },
  // Only Row border bottom is applicable
  "Table.Row.Border.Bottom.Width": {
    defaultValue: "1px"
  },
  "Table.Row.Hover.Bg.Color": {
    ref: "Color.Gray.100"
  },

  // Column
  "Table.Column.Header.Bg.Color": {
    ref: "Color.Gray.200"
  },
  "Table.Column.Header.Color": {
    ref: "Color.Gray.800"
  },
  "Table.Column.Header.Font.Size": {
    ref: "Font.Size.14"
  },
  "Table.Column.Header.Font.Weight": {
    ref: "Font.Weight.SemiBold"
  },
  "Table.Column.Header.Icon.Color": {
    ref: "Color.Gray.700"
  },

  // Cell
  "Table.Cell.Padding.Top": {
    ref: "Space.16"
  },
  "Table.Cell.Padding.Right": {
    ref: "Space.8"
  },
  "Table.Cell.Padding.Bottom": {
    ref: "Space.16"
  },
  "Table.Cell.Padding.Left": {
    ref: "Space.8"
  },

  // Footer
  "Table.Footer.Bg.Color": {
    ref: "Color.Gray.200",
    referredIn: ["Table.Footer.Active.Bg.Color"]
  },
  "Table.Footer.Color": {
    ref: "Color.Gray.700"
  },
  "Table.Footer.Font.Weight": {
    ref: "Font.Weight.Medium"
  },
  "Table.Footer.Icon.Color": {
    ref: "Color.Gray.700"
  },
  "Table.Footer.Padding.Top": {
    ref: "Space.8"
  },
  "Table.Footer.Padding.Right": {
    ref: "Space.12"
  },
  "Table.Footer.Padding.Bottom": {
    ref: "Space.8"
  },
  "Table.Footer.Padding.Left": {
    ref: "Space.12"
  },
  "Table.Footer.Active.Bg.Color": {
    valueFunc: (meta) => {
      return darken(getValue("Table.Footer.Bg.Color", meta), 0.2);
    }
  },

  //table view

  "Table.Bg.Color": {
    ref: "Color.White"
  },

  "Table.Overflow": {
    defaultValue: "auto"
  },

  "Table.Height": {
    defaultValue: "500px"
  },
  "Table.Width": {
    defaultValue: "100%"
  },
  "Table.Min.Height": {
    defaultValue: "0px"
  },
  "Table.Min.Width": {
    defaultValue: "750px"
  },
  "Table.Max.Height": {
    defaultValue: "unset"
  },
  "Table.Max.Width": {
    defaultValue: "unset"
  },

  "Table.Margin.Top": {
    defaultValue: "0px"
  },
  "Table.Margin.Right": {
    defaultValue: "0px"
  },
  "Table.Margin.Bottom": {
    defaultValue: "0px"
  },
  "Table.Margin.Left": {
    defaultValue: "0px"
  },

  "Table.Padding.Top": {
    defaultValue: "0px"
  },
  "Table.Padding.Right": {
    defaultValue: "0px"
  },
  "Table.Padding.Bottom": {
    defaultValue: "0px"
  },
  "Table.Padding.Left": {
    defaultValue: "0px"
  },

  "Table.Border.Style": {
    defaultValue: "solid"
  },
  "Table.Border.Color": {
    ref: "Color.Transparent"
  },

  "Table.Border.Left.Width": {
    defaultValue: "0px"
  },
  "Table.Border.Right.Width": {
    defaultValue: "0px"
  },
  "Table.Border.Top.Width": {
    defaultValue: "0px"
  },
  "Table.Border.Bottom.Width": {
    defaultValue: "0px"
  },

  "Table.Border.Top.Left.Radius": {
    defaultValue: "0px"
  },
  "Table.Border.Top.Right.Radius": {
    defaultValue: "0px"
  },
  "Table.Border.Bottom.Right.Radius": {
    defaultValue: "0px"
  },
  "Table.Border.Bottom.Left.Radius": {
    defaultValue: "0px"
  },

  "Table.Shadow": {
    defaultValue: "none"
  },
  "Table.Shadow.Type": {
    defaultValue: "none"
  },
  "Table.Shadow.Color": {
    ref: "Color.Shadow"
  },
  "Table.Box.Sizing": {
    defaultValue: "border-box"
  }
};
